import { RestClient } from '@superbet-group/web.lib.rest';

import {
    TvChannelsDto,
    TvChannelEvent,
} from '@sportOfferFederation/tvChannels/services/types';
import { TvChannel } from '@sportOfferFederation/tvChannels/types';

export function createTvChannelsGetter(
    client: RestClient,
    iconHost: string,
): (country: string, region: string) => Promise<Record<number, TvChannel[]>> {
    return async function getTvChannels(
        country: string,
        region: string,
    ): Promise<Record<number, TvChannel[]>> {
        try {
            const response = await client.get<TvChannelsDto>(
                `/media/tvguide/${country}superbetsport/${country}`,
            );
            return mapTvChannels(response, region);
        } catch (e) {
            return {};
        }
    };

    function mapTvChannels(dto: TvChannelsDto, region: string): Record<number, TvChannel[]> {
        const mapping: Record<number, TvChannel[]> = {};

        for (let event of dto.events) {
            if (!event.event_id) {
                continue;
            }
            const channels = getChannels(event, region);
            if (channels.length === 0) {
                continue;
            }
            mapping[event.event_id.value] = channels;
        }

        return mapping;
    }

    function getChannels(event: TvChannelEvent, region: string): TvChannel[] {
        return event.channels
            .filter((channel) => channel.regions.includes(region))
            .map((channel) => {
                return {
                    name: channel.name,
                    iconUrl: getChannelIconUrl(channel.name),
                };
            });
    }

    function getChannelIconUrl(name: string): string {
        const filename = `${name}/Light.svg`;

        return `${iconHost}/app-assets/tv-channels-v2/${filename}`;
    }
}
